const TZ_SUFFIX = /[Zz]|[+-]\d{2}(?::?\d{2})?$/;
const TZ_HH_ONLY = /([+-]\d{2})$/;
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function parseDbTimestamp(
  value: string | Date | null | undefined,
): Date | null {
  if (value == null) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value !== 'string') return null;

  const trimmed = value.trim();
  if (trimmed === '') return null;

  // 'YYYY-MM-DD' already parses as UTC midnight per ISO 8601; respect it as-is.
  if (DATE_ONLY.test(trimmed)) {
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  let normalized = trimmed;
  if (normalized.includes(' ') && !normalized.includes('T')) {
    normalized = normalized.replace(' ', 'T');
  }
  if (!TZ_SUFFIX.test(normalized)) {
    normalized = `${normalized}Z`;
  } else {
    // Postgres emits `+00` / `-03` (HH only); expand to `+00:00` so Date parses it.
    normalized = normalized.replace(TZ_HH_ONLY, '$1:00');
  }

  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
